import { Env } from '../../core/env';
import { VariationAction } from '../actions/variation_action';
import { VariationContainer } from '../views/pc/variation_container';
import { ItemInformationErrorReportAction } from '../../item/actions/item_information_error_report_action';
import { AddRecommendationItemAction } from '../../search/addRecommendationItem/actions/add_recommendation_item_action';
import { AddRecommendationItemContainer } from '../../search/addRecommendationItem/views/pc/add_recommendation_item_container';
import { SubstituteItemAreaAnalytics } from '../../core/actions/analytics/substitute_item_area_analytics';
import { ReviewValuerAnalytics } from '../../core/actions/analytics/review_valuer_analytics';
import { ReviewCardAnalytics } from '../../core/actions/analytics/review_card_analytics';
import { ReviewListAreaAnalytics } from '../../core/actions/analytics/review_list_area_analytics';
import { ReviewButtonAnalytics } from '../../core/actions/analytics/review_button_analytics';
import { TableTooltipAnalytics } from '../../core/actions/analytics/table_tooltip_analytics';
import { AsyncVariationListPagingAnalytics } from '../../core/actions/analytics/async_variation_list_paging_analytics';
import { ComparisonTableAction } from '../../core/actions/comparison_table/comparison_table_action';
import { BulkAddCartAction } from '../../core/actions/add_cart/bulk_add_cart_action';
import { DisplayTypeForBulkAddCart } from '../../core/actions/analytics/bulk_add_cart_analytics';
import { CouponModalAction } from '../../core/actions/coupon/coupon_modal_action';

document.addEventListener('DOMContentLoaded', () => {
  new SubstituteItemAreaAnalytics(); // NOSONAR

  VariationAction.init(Env, VariationContainer);

  // 商品情報誤り報告モーダル
  ItemInformationErrorReportAction.init();

  // 推奨品登録モーダル
  AddRecommendationItemAction.init(Env, AddRecommendationItemContainer);

  // 比較表
  ComparisonTableAction.init(Env);

  // クーポンモーダル
  CouponModalAction.init(Env);

  new ReviewCardAnalytics(); // NOSONAR

  new ReviewValuerAnalytics(); // NOSONAR

  new ReviewListAreaAnalytics(); // NOSONAR

  new TableTooltipAnalytics(); // NOSONAR

  new AsyncVariationListPagingAnalytics(); // NOSONAR

  // 画像無しバリエにおける、複数商品を一括でカゴ追加できる機能。
  BulkAddCartAction.init({
    bulkAddCartButtonsClass: 'bulkAddCartButton',
    displayType: DisplayTypeForBulkAddCart.NoImageVariation
  });

  (window as any ).ReviewButtonAnalytics = new ReviewButtonAnalytics(VariationAction);//NOSONAR
});
